"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Button_1 = __importDefault(require("./Button"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var Pagination = function (_a) {
    var page = _a.page, onPageChange = _a.onPageChange, className = _a.className, disabled = _a.disabled, _b = _a.showItemsPerPageSelector, showItemsPerPageSelector = _b === void 0 ? false : _b, _c = _a.itemsPerPage, itemsPerPage = _c === void 0 ? 10 : _c, onItemsPerPageChange = _a.onItemsPerPageChange, totalItems = _a.totalItems, _d = _a.truncate, truncate = _d === void 0 ? true : _d, _e = _a.span, span = _e === void 0 ? 2 : _e;
    // page values
    var pages = Math.ceil(totalItems / itemsPerPage);
    var pageValue = page < 1 ? 1 : (page > pages ? pages : page);
    // span
    var options = [pageValue];
    for (var i = pageValue + 1; i < pageValue + span + 1; i++) {
        if (i > 0 && i <= pages) {
            options.push(i);
        }
    }
    for (var i = pageValue - 1; i > pageValue - span - 1; i--) {
        if (i > 0) {
            options.unshift(i);
        }
    }
    // next & prev
    var showPrevButton = pageValue > 1;
    var showNextButton = pageValue < pages;
    var showPrevTruncation = truncate && pageValue > span + 1;
    var showNextTruncation = truncate && pages - pageValue > span;
    // render
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-pagination", disabled && 'disabled', className) },
        showPrevButton && (react_1.default.createElement(Button_1.default, { icon: "chevron_left", text: "", onClick: function () { return onPageChange(pageValue - 1); }, disabled: disabled, variant: "tertiary", iconButtonSize: "large" })),
        showPrevTruncation && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.default, { text: "1", onClick: function () { return onPageChange(1); }, disabled: disabled, variant: "tertiary" }),
            react_1.default.createElement(Button_1.default, { text: "...", onClick: function () { return null; }, disabled: true, variant: "tertiary" }))),
        options.map(function (o, i) { return (react_1.default.createElement(Button_1.default, { key: o, text: String(o), onClick: function () { return onPageChange(o); }, variant: pageValue === o ? 'secondary' : 'tertiary', disabled: disabled })); }),
        showNextTruncation && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Button_1.default, { text: "...", onClick: function () { return null; }, disabled: true, variant: "tertiary" }),
            react_1.default.createElement(Button_1.default, { text: String(pages), onClick: function () { return onPageChange(pages); }, disabled: disabled, variant: "tertiary" }))),
        showNextButton && (react_1.default.createElement(Button_1.default, { icon: "chevron_right", text: "", onClick: function () { return onPageChange(pageValue + 1); }, disabled: disabled, variant: "tertiary" })),
        showItemsPerPageSelector && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Dropdown_1.default, { value: itemsPerPage, options: [
                    { label: '5', value: 5 },
                    { label: '10', value: 10 },
                    { label: '20', value: 20 },
                    { label: '50', value: 50 },
                ], onChange: function (v) { return onItemsPerPageChange && onItemsPerPageChange(v.value); }, disabled: disabled }),
            react_1.default.createElement("span", null,
                "of ",
                totalItems,
                " items")))));
};
exports.default = Pagination;
